import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/SESSION';

export const {action: showExisting} = createAction(
    `${domain}/SHOW_EXISTING`,
    (
        session,
        showSessionsInWeekends,
        allowFundableSessions,
        sessionClosingDayOptions,
        canSetBillOnChildSickOnSessions,
        canSetBillOnChildAbsentOnSessions,
    ) => ({
        session,
        showSessionsInWeekends,
        allowFundableSessions,
        sessionClosingDayOptions,
        canSetBillOnChildSickOnSessions,
        canSetBillOnChildAbsentOnSessions,
    }),
);

export const {action: showSessionVersions} = createAction(`${domain}/SHOW_SESSION_VERSIONS`, show => ({show}));

export const {action: changeVersion} = createAction(`${domain}/CHANGE_VERSION`, newVersion => ({newVersion}));

export const {action: newVersion} = createAction(`${domain}/NEW_VERSION`, () => ({}));

export const {action: showNew} = createAction(
    `${domain}/SHOW_NEW`,
    ({
        institutionId,
        sessionType,
        showSessionsInWeekends,
        allowFundableSessions,
        sessionClosingDayOptions,
        canSetBillOnChildSickOnSessions,
        canSetBillOnChildAbsentOnSessions,
    }) => ({
        institutionId,
        sessionType,
        showSessionsInWeekends,
        allowFundableSessions,
        sessionClosingDayOptions,
        canSetBillOnChildSickOnSessions,
        canSetBillOnChildAbsentOnSessions,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: ready} = createAction(`${domain}/READY`, () => ({}));

export const {action: toggleWeekdays} = createAction(`${domain}/TOGGLE_WEEKDAYS`, () => ({}));
